import React, { useEffect, useState } from "react";
import api from "../../../lib/api";
import { fmtPrice } from "../../../lib/format";

const REASONS = {
  CARD_DECLINED_RISK: "Card declined by Ziina's security check · رفضت Ziina البطاقة للحماية",
  CARD_DECLINED: "Card declined by the bank · البنك رفض البطاقة",
  INSUFFICIENT_FUNDS: "Insufficient funds · الرصيد غير كافٍ",
  PAYMENT_EXPIRED: "Payment page expired · انتهت صلاحية صفحة الدفع",
};

const reason = (o) => {
  const e = o.payment_error;
  if (!e) return "Customer left the payment page · العميل طلع من صفحة الدفع بدون ما يكمّل";
  return REASONS[e.code] || `${e.code}: ${e.message}`;
};

export function FailedPayments() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/orders", { params: { include_unpaid: true } })
      .then((r) => setList(r.data.filter((o) => o.cancel_reason === "unpaid")))
      .catch(() => {});
  }, []);
  if (!list.length) return null;
  return (
    <details className="mt-12 border border-[#262421] p-5" data-testid="admin-failed-payments">
      <summary className="cursor-pointer text-sm text-[#C49A6C]">Unfinished payments · دفعات ما اكتملت ({list.length})</summary>
      <p className="text-xs text-[#6E685F] mt-3">Nothing was charged for these. They are not counted in sales or stock.</p>
      <div className="mt-4 space-y-3">
        {list.map((o) => (
          <div key={o.id} className="flex flex-wrap justify-between gap-3 text-xs border-t border-[#262421] pt-3" data-testid={`failed-payment-${o.order_number}`}>
            <div>
              <p className="text-[#D4C3B3]">{o.order_number} · {o.customer?.full_name} · {o.customer?.email} · {o.customer?.phone}</p>
              <p className="text-[#8A857D] mt-1" data-testid={`failed-payment-reason-${o.order_number}`}>{reason(o)}</p>
            </div>
            <p className="text-[#8A857D]">{fmtPrice(o.total, o.currency)}</p>
          </div>
        ))}
      </div>
    </details>
  );
}
